import { Observable } from "rxjs"
import PoolStatisticsDetails from "./RandomsModel/PoolStatisticsDetails"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function PoolStatisticsDetailsGetObservable(poolId: number, companyId?: number): Observable<PoolStatisticsDetails> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString(),
    companyId: (companyId || 0).toString()
  }).toString()

  return ObservableFromFetch<PoolStatisticsDetails>("RandomTest/GetPoolStatisticsDetails?" + requestBody)
}

export function PoolStatisticsDetailsByProgram(poolId: number, poolProgramId?: number): Observable<PoolStatisticsDetails> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString(),
    poolProgramId: (poolProgramId || 0).toString()
  }).toString()

  return ObservableFromFetch<PoolStatisticsDetails>("RandomTest/PoolStatisticsDetailsByProgram?" + requestBody)
}
